module.exports = __webpack_public_path__ + "media/lost_2.5fc0843a.mp3";